var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLikeActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 42,
    height: 42,
    rx: 6,
    fill: "#7043FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.5424 13.5424C21.8325 13.5424 21.257 14.1178 21.257 14.8277V15.8559C21.257 18.291 19.4751 20.3099 17.144 20.6796V26.1385C17.144 27.4162 18.1799 28.452 19.4576 28.452H26.6554C26.6772 28.452 26.699 28.453 26.7207 28.4548C27.0594 28.4836 27.6872 28.1429 27.9583 27.0025L28.9672 21.9578C28.932 21.2794 28.3708 20.7401 27.6836 20.7401H24.5989C24.173 20.7401 23.8277 20.3949 23.8277 19.969V14.8277C23.8277 14.1178 23.2522 13.5424 22.5424 13.5424ZM16.9287 29.0494C17.6057 29.638 18.49 29.9944 19.4576 29.9944H26.6259C28.0955 30.0968 29.1274 28.7731 29.4627 27.3427C29.4646 27.3345 29.4664 27.3263 29.4681 27.318L30.4963 22.1767C30.5063 22.1269 30.5113 22.0762 30.5113 22.0255C30.5113 20.4638 29.2453 19.1978 27.6836 19.1978H25.3701V14.8277C25.3701 13.266 24.1041 12 22.5424 12C20.9807 12 19.7147 13.266 19.7147 14.8277V15.8559C19.7147 17.7016 18.2185 19.1978 16.3728 19.1978H13.2881C12.2943 19.1978 11.4886 20.0034 11.4886 20.9972V28.195C11.4886 29.1888 12.2943 29.9944 13.2881 29.9944H15.3446C16.0292 29.9944 16.6245 29.6121 16.9287 29.0494ZM15.6017 20.7401H13.2881C13.1461 20.7401 13.031 20.8552 13.031 20.9972V28.195C13.031 28.337 13.1461 28.452 13.2881 28.452H15.3446C15.4866 28.452 15.6017 28.337 15.6017 28.195V20.7401Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLikeActive);
export default __webpack_public_path__ + "static/media/likeActive.998f515f7de98f0d3e2628a4a5619544.svg";
export { ForwardRef as ReactComponent };